import React from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  Hotel,
  MedicalServices as DepartmentIcon,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import InPatient from './InPatient';

// Menu config — `key` MUST match the `component_name` registered in the DB
// for permission filtering. Add a new section by appending here.
// Ward Assignments has been moved to the Admin Panel — only administrators
// should be assigning nurses to wards.
// `render` is used (instead of `component`) so each section receives the
// DepartmentLayout navigate context, letting one section jump to another —
// e.g. the Home dashboard's compliance FAB sending the nurse straight into
// the InPatient workspace with the selected patient already focused.
const MENU_ITEMS = [
  { key: 'Home',                 label: 'Home',                 icon: <ReceiptLongIcon />, render: (ctx) => <Home      navigate={ctx.navigate} /> },
  { key: 'InPatient',            label: 'InPatient / Detention',icon: <Hotel />,            render: (ctx) => <InPatient navigate={ctx.navigate} /> },
];

export default function Wards() {
  return (
    <DepartmentLayout
      departmentId={5}
      departmentName="Wards & Nursing Services"
      departmentIcon={<DepartmentIcon />}
      menuItems={MENU_ITEMS}
    />
  );
}
